import { QCM_GREEN } from '../../utils/qcmTheme';

/**
 * Anneau de progression SVG (réponses reçues / élèves). Vert plein quand
 * toute la classe a répondu.
 */
const ProgressRing = ({ ratio = 0, size = 38 }) => {
  const r = (size - 6) / 2;
  const circ = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(1, ratio));

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,.15)" strokeWidth="6" />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={QCM_GREEN}
        strokeWidth="6"
        strokeLinecap="round"
        strokeDasharray={circ}
        strokeDashoffset={circ * (1 - clamped)}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset .45s cubic-bezier(.2,.8,.3,1)' }}
      />
    </svg>
  );
};

export default ProgressRing;
